<template>
    <small class="c-field__message u-color-danger">
        <i class="fa fa-times-circle"></i> {{ errorMessage }}
    </small>
</template>

<script>
export default {
    props: ['errors', 'attribute'],

    computed: {
        errorMessage() {
            const error = this.errors.filter((error) => error.$property === this.attribute).shift();
            return error.$message;
        }
    }
};
</script>
